import { groupByDay, time } from './lessonDates';
import './styles/slotPicker.scss';

type Slot = { id: string; start: string; durationMinutes: number };

// Shared "pick an open lecturer slot to book" grid — one day per card. Used by
// both the running-state schedule (LecturesZone) and the journey booking card
// (BookingCalendar) so the offered-terms list looks identical in every course
// state. Purely presentational: the caller owns the credit/empty-state copy and
// the booking handler.
export default function SlotPicker({ slots, onBook }: { slots: Slot[]; onBook: (slotId: string) => void }) {
    const slotDays = groupByDay(slots);
    return (
        <div className="slotPicker">
            {slotDays.map((g, gi) => (
                <div key={gi} className="spDay">
                    <div className="spHead">
                        <span className="d">{g.day}.</span>
                        <span className="m">{g.month}</span>
                        <span className="wd">{g.weekday}</span>
                    </div>
                    <div className="spSlots">
                        {g.items.map(s => (
                            <div key={s.id} className="spSlot" onClick={() => onBook(s.id)}>{time(s.start)}</div>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
}
